import Select from 'react-select';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const styleDefault = {
  control: (provided, state) => ({
    position: 'relative',
    display: 'inline-flex',
    width: 'auto',
    height: 36,
    border: 'none',
    fontWeight: '500',
    fontSize: '14px',
    color: '#000000',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    outline: 'none',
    cursor: 'pointer',
  }),
  //드롭박스
  menu: (provided, state) => ({
    ...provided,
    borderRadius: '2px',
    width: state.selectProps.width,
    color: state.selectProps.menuColor,
    boxShadow: '0 3px 6px 0 rgba(35, 44, 81, 0.15)',
    border: 'solid 1px #e2e5ec',
    padding: 0,
    margin: 0,
  }),
  //드롭박스>메뉴
  menuList: styles => ({
    padding: '0',
  }),
  //드롭박스>메뉴>옵션
  option: (provided, state) => {
    return {
      ...provided,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      height: 36,
      padding: '0 10px',
      fontSize: '14px',
      color: state.isSelected ? '#0b6fe8' : '#323232',
      backgroundColor: state.isSelected ? '#f3f6fb' : '#fff',
      cursor: 'pointer',
    };
  },
  placeholder: () => ({ color: '#323232' }),
};

export const CustomSelect = styled(Select)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  // 넓이 커스텀 : 컴포넌트에 width="000px" 설정시 적용가능
  ${props =>
    props.width &&
    css`
      max-width: ${props.width};
    `}

  [class*='-Control'] {
    width: 100%;
  }
  [class*='-Input'] {
    display: none;
  }
  [class*='-menu'] {
    flex: none;
  }
  [class*='-ValueContainer'] {
    display: flex;
    align-items: center;
    padding: 2px 4px;
    [class*='-dummyInput-DummyInput'] {
      width: 0;
    }
  }
  [class*='-singleValue'] {
    margin: 0;
  }
  [class*='-indicatorSeparator'] {
    // 화살표 왼쪽 바
    display: none;
  }
  [class*='-indicatorContainer'] {
    // 화살표
    width: 15px;
    padding: 0;
    svg {
      width: 15px;
      margin: 0 auto;
      fill: #6c7293;
    }
  }
`;
